// eslint-disable-next-line
// @ts-nocheck

import { Box, Button, Card, Stack, TextField, Typography } from '@mui/material';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import Page from '../../components/Page';
import { useResetPasswordMutation } from '../../store/api/userApi';

const passwordSchema = Yup.object().shape({
  password: Yup.string().required('Password is required').min(6, 'Password is too short'),
  confirmpassword: Yup.string()
    .required('Confirm Password is required')
    .oneOf([Yup.ref('password')], 'Passwords must match'),
});

export default function ResetPassword() {
  const navigate = useNavigate();
  const [resetPassword, resetPasswordResponse] = useResetPasswordMutation();
  const authData = JSON.parse(localStorage.getItem('login') || '{}');

  const [formValues, setFormValues] = useState({
    password: '',
    confirmpassword: '',
  });
  const updateCustomerData = async (values: any, action: any) => {
    await resetPassword({
      payload: {
        merchantId: authData.merchantId,
        password: values.password,
        userId: authData.userId,
        category: authData.userType,
      },
      token: authData.token,
    });
    action.resetForm();
  };

  return (
    <Page title="Reset Password">
      <Box>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            Reset Password
          </Typography>
        </Stack>
        <Card>
          <Formik
            enableReinitialize
            initialValues={formValues}
            onSubmit={updateCustomerData}
            validationSchema={passwordSchema}
          >
            {({ handleBlur, handleChange, handleSubmit, values, touched, errors }) => (
              <Box className="lg:mx-[110px] md:mx-[60px] mx-[20px]  mt-10 px-[10px]">
                <Box
                  className="mt-5"
                  style={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box className="mt-5" style={{ width: '90%', marginTop: '30px', marginLeft: '40px' }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      type="password"
                      name="password"
                      id={'password'}
                      label={values.password ? '' : 'New Password'}
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.password && errors.password)}
                      helperText={touched.password && errors.password}
                    />
                  </Box>
                </Box>
                <Box style={{ width: '90%', marginTop: '30px', marginLeft: '40px' }} className="mt-5">
                  <TextField
                    fullWidth
                    variant="outlined"
                    type="password"
                    name="confirmpassword"
                    label={'Confirm Password'}
                    value={values.confirmpassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`form-control ${errors.confirmpassword ? 'is-invalid' : ''}`}
                    error={Boolean(touched.confirmpassword && errors.confirmpassword)}
                    helperText={touched.confirmpassword && errors.confirmpassword}
                  />
                  <div className="border-b-[1px] mt-6 mb- text-slate-600 "></div>
                </Box>

                <div
                  style={{
                    marginTop: '20px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginRight: '100px',
                    marginBottom: '30px',
                  }}
                >
                  <Button
                    variant="contained"
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                    onClick={() => {
                      navigate('/dashboard/app');
                    }}
                    sx={{ marginRight: '10px' }}
                    size="large"
                  >
                    Cancel
                  </Button>
                  <Button
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                    variant="contained"
                    onClick={() => {
                      handleSubmit();
                    }}
                    size="large"
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Box>
            )}
          </Formik>
        </Card>
      </Box>
    </Page>
  );
}
